import { styled } from '@styles/theme'

export const LoaderStyles = {
	Container: styled('div', {
		display: 'flex',
		justifyContent: 'center',
	}),
}
